import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { initAnalytics, setAnalyticsEnabled, trackPageView } from '../lib/analytics';
import { isPublicRoute } from '../lib/publicRoutes';

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const hasConsented = localStorage.getItem('cookieConsent');
    if (!hasConsented) {
      // Show banner after a short delay for better UX
      setTimeout(() => {
        setShowBanner(true);
      }, 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowBanner(false);
    // Consent just granted — start analytics now so this entry page view is captured
    // (PageTracker otherwise only fires on the next navigation). Public pages only.
    if (isPublicRoute(window.location.pathname)) {
      initAnalytics();
      setAnalyticsEnabled(true);
      trackPageView(window.location.pathname);
    }
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowBanner(false);
    setAnalyticsEnabled(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6 animate-slide-up">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-lg shadow-2xl border border-gray-200 p-4 sm:p-6">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex-1">
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 mt-1">
                  <svg
                    className="h-6 w-6 text-ocean-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <div className="flex-1">
                  <h3 className="text-sm font-semibold text-gray-900 mb-1">
                    We use cookies
                  </h3>
                  <p className="text-sm text-gray-600">
                    We use essential cookies to make our site work and analytics cookies to help us improve.
                    By clicking "Accept", you agree to our use of cookies.{' '}
                    <Link
                      to="/privacy"
                      className="text-ocean-600 hover:text-ocean-700 underline font-medium"
                    >
                      Learn more
                    </Link>
                  </p>
                </div>
              </div>
            </div>

            <div className="flex items-center space-x-3 w-full sm:w-auto">
              <button
                onClick={handleDecline}
                className="flex-1 sm:flex-initial px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
              >
                Decline
              </button>
              <button
                onClick={handleAccept}
                className="flex-1 sm:flex-initial px-4 py-2 text-sm font-medium text-white bg-ocean-600 rounded-md hover:bg-ocean-700 transition-all shadow-sm hover:shadow-md"
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
